export const SkeletonElement = () => (
  <div className='h-4 w-full animate-pulse rounded bg-gray-200'></div>
);
